export default __webpack_public_path__ + "static/KatarzynaChepelova-33b7de8e150a9625d57a302214d0b5a8.png";